import React from 'react';
import { Box, Typography } from '@mui/material';

export default function LinhaProducao() {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h5">Linha de Produção</Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>Página de gerenciamento da linha de produção (placeholder).</Typography>
    </Box>
  );
}
